export default "__VITE_ASSET__CTPRwqEM__"